import { Euler } from 'three';

import { stripCharacterIdInstanceSuffix } from '../../../shared/freeCharacterMesh';
import { DEFAULT_MOTION_SCENE_CHARACTER_ROTATION } from '../../../shared/motionScene';
import { MOTION_EDITOR_RESOURCE_DOMAIN } from '../resources';

interface MotionEditorDefaultCharacter {
  heroThumbnailPath: string;
  jobID: string;
  jointJsonPath: string;
  meshPath: string;
  thumbnailPath: string;
  rotationOffsets?: undefined;
}

const LEGACY_CHARACTER_ROTATION = new Euler(0, 0, 0);
const LEGACY_CHARACTER_ID_PREFIX = 'char-generation';

export function isLegacyMotionEditorCharacterId(characterID: string) {
  return stripCharacterIdInstanceSuffix(characterID).startsWith(
    LEGACY_CHARACTER_ID_PREFIX,
  );
}

function isLegacyMotionEditorCharacterCreatedBy(createdBy: string) {
  return createdBy.startsWith('user-') || createdBy.startsWith('service-');
}

export function resolveIsLegacyMotionEditorCharacter({
  characterID,
  createdBy,
}: {
  characterID: string;
  createdBy?: string;
}) {
  return (
    isLegacyMotionEditorCharacterId(characterID) ||
    (createdBy != null && isLegacyMotionEditorCharacterCreatedBy(createdBy))
  );
}

export function getMotionEditorCharacterRotation(isLegacyCharacter: boolean) {
  return isLegacyCharacter
    ? LEGACY_CHARACTER_ROTATION
    : DEFAULT_MOTION_SCENE_CHARACTER_ROTATION;
}

export const DEFAULT_CHARACTER: MotionEditorDefaultCharacter = {
  jobID: 'char-upload-Axel',
  heroThumbnailPath: `${MOTION_EDITOR_RESOURCE_DOMAIN}/character-uploads/FREE_CHARACTERS/char-upload-Axel/hero-thumbnail.png`,
  jointJsonPath: `${MOTION_EDITOR_RESOURCE_DOMAIN}/character-uploads/FREE_CHARACTERS/char-upload-Axel/character.json`,
  meshPath: `${MOTION_EDITOR_RESOURCE_DOMAIN}/character-uploads/FREE_CHARACTERS/char-upload-Axel/character.glb`,
  thumbnailPath: `${MOTION_EDITOR_RESOURCE_DOMAIN}/character-uploads/FREE_CHARACTERS/char-upload-Axel/thumbnail.png`,
};
